export default __webpack_public_path__ + "22daf365d1c6e17aac0540259dceead8.jpg";